/* eslint-disable max-len */
import styled from 'styled-components';
import DarkFeatherIcon from '../../assets/images/feather-icon.svg';
import LightFeatherIcon from '../../assets/images/feather-icon-light.svg';

const FeatherIcon = styled.span`
  background: ${(props) =>
    props.theme.palette.type === 'dark'
      ? `url("${DarkFeatherIcon}") no-repeat left center`
      : `url("${LightFeatherIcon}") no-repeat left center`};
  background-size: 32px 32px;
  display: inline-block;
  position: relative;
  width: 80px;
  margin-left: 31px;
  height: 32px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    margin-left: 43px;
  }

  ${(props) => props.theme.breakpoints.down('xs')} {
    width: 40px;
    margin-left: 19px;
  }
`;

export default FeatherIcon;
